import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router, RouterLink } from "@angular/router";
import { NgOptimizedImage } from '@angular/common';
import { KazHeaderSearchComponent } from '../../components/kaz-header-search/kaz-header-search.component';
import { KazDesktopNavComponent } from '../../components/kaz-desktop-nav/kaz-desktop-nav.component';
import { KazFooterComponent } from '../../components/kaz-footer/kaz-footer.component';

@Component({
    selector: 'kaz-no-frame',
    templateUrl: './no-frame.component.html',
    styleUrls: ['./no-frame.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgOptimizedImage, RouterLink, KazHeaderSearchComponent, KazDesktopNavComponent, KazFooterComponent]
})
export class NoFrameComponent implements OnInit{
  private _router = inject(Router);

  showLogin: boolean = false;

  showLoginBtn: boolean = false;
  showSignUpBtn: boolean = false;

  ngOnInit() {
    this.isLogin();
    this.isSignUp();
    if (this._router.url.includes('signup')) {
      this.showLogin = true;
    }
  }

  isLogin(){
    this.showLoginBtn = !this._router.url.includes('login');

  }

  isSignUp(){
    this.showSignUpBtn = !this._router.url.includes('signup');
  }
}
